module.exports = __webpack_public_path__ + "img/logo.bb724320.png";